// import React, { useState, useEffect, useContext, useMemo } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import "../../../FinQ/FinQSection/FinQSection.css"
// import "../../CoPms/CoPmsSection/CoPmsSection.css"
// import { tabsClasses } from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Box from "@mui/material/Box";
// import TabPanel from "@mui/lab/TabPanel";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import animation from "../../../../images/jm-animation.gif";
// import VideoGallery from "../../../FinQ/VideoGallery/VideoGallery";
// import DocumentGallery from "./DocumentGallery/DocumentGallery";
// import Calendar2026 from "../../../FinQ/FinQSection/Calendar/Calendar2026";
// import Outlook2026 from "./Outlook2026/Outlook2026";

// function CoPmsSection() {
//   const [value, setValue] = useState(1);
//   const [loadingshow, setloadingshow] = useState(false);
//   const [breadcrumbs, setBreadcrumbs] = useState([]);

//   const [pathname, setPathName] = useState("");

//   useEffect(() => {
//     var pathname = window.location.pathname;
//     const regEx = new RegExp("-", "g");
//     const resultName = pathname.replace(regEx, " ");
//     setPathName(resultName);
//   });

//   useEffect(() => {
//     setloadingshow(true);
//     const para = window.location.pathname.toLowerCase().split("/")[2];
//     if (para === "videogallery") {
//       setValue(1);
//       setBreadcrumbs(["Insights", "Video Gallery"]);
//     } else if (para === "documentgallery") {
//       setValue(2);
//       setBreadcrumbs(["Insights", "Document Gallery"]);
//     }else if(para === "calendar2026"){
//       setValue(3);
//       setBreadcrumbs(["Insights", "Calendar 2026"])
//     }
//     else if(para === "outlook2026"){
//       setValue(4);
//       setBreadcrumbs(["Insights", "Outlook 2026"])
//     }
//     setloadingshow(false);
//   }, []);

//   const arrayOfTabsObj = [
//     { name: "Video Gallery", id: 1 },
//     { name: "Document Gallery", id: 2 },
//     {name : "Calendar 2026", id : 3},
//      {name : "Outlook 2026", id : 4},
//   ];

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const navigateToSection = (section) => {
//     setValue(section.id);
//     setBreadcrumbs(["Insights", section.name]);
//     window.history.pushState(
//       "",
//       "",
//       `/Insights/${section.name.replace(/\s/g, "-")}`
//     );
//   };

//   return (
//     <>
//       <section className="FinQSection-detail">
//         <Container>
//           <Row>
//             <Col>
//               <ul className="navigator-arrow">
//                 <li>
//                   <a href="/">
//                     <i className="fa fa-home" aria-hidden="true"></i>
//                   </a>{" "}
//                   <i className="fa fa-angle-right" aria-hidden="true"></i>
//                 </li>
//                 <li>
//                   <a href="/Insights">
//                     <i>Insights</i>
//                   </a>{" "}
//                   <i className="fa fa-angle-right" aria-hidden="true"></i>
//                 </li>
//                 {/* <li>Calculator</li><i className="fa fa-angle-right" aria-hidden="true"></i> */}
//                 {window.location.pathname !== "/Insights" ? (
//                   <li>{pathname.split("/")[2]}</li>
//                 ) : (
//                   ""
//                 )}
//               </ul>
//             </Col>
//           </Row>
//         </Container>
//         <Box >
//           <TabContext value={value}>
//             <Container className="finqtab">
//               <Row>
//                 <Col sm={12}>
//                   <Box
//                     sx={{
//                       borderBottom: 0,
//                       borderColor: "divider",
//                       bgcolor: "background.paper",
//                     }}
//                   >
//                     <TabList
//                       onChange={handleChange}
//                       variant="scrollable"
//                       sx={{
//                         [`& .${tabsClasses.scrollButtons}`]: {
//                           "&.Mui-disabled": { opacity: 0.3 },
//                         },
//                       }}
//                       scrollButtons="auto"
//                     >
//                       {arrayOfTabsObj.map((item) => (
//                         <Tab
//                           label={item.name}
//                           value={item.id}
//                           key={item.id}
//                           onClick={() => navigateToSection(item)}
//                         />
//                       ))}
//                       {loadingshow && (
//                         <div className="textcentervertex">
//                           <img src={animation} alt="Loading" />
//                           <div className="model_popup">Please Wait...</div>
//                         </div>
//                       )}
//                     </TabList>
//                   </Box>
//                 </Col>
//               </Row>
//             </Container>
//             <div className="section-header">
//               <h2 className="sectionHeaderFinQ">
//                 {value === 1 ? "" : arrayOfTabsObj[value - 1].name}
//               </h2>
//             </div>
//             <TabPanel value={1}>
//               <Container>
//                 <Row>
//                   <Col sm={12}>
//                     <VideoGallery />
//                   </Col>
//                 </Row>
//               </Container>
//             </TabPanel>
//             <TabPanel value={2}>
//               <Container>
//                 <Row>
//                   <Col sm={12}>
//                     <DocumentGallery />
//                   </Col>
//                 </Row>
//               </Container>
//             </TabPanel>

//             <TabPanel value={3}>
//               <Container>
//                 <Row>
//                   <Col sm={12}>
//                     <Calendar2026 />
//                   </Col>
//                 </Row>
//               </Container>
//             </TabPanel>

//             <TabPanel value={4}>
//               <Container>
//                 <Row>
//                   <Col sm={12}>
//                     <Outlook2026 />
//                   </Col>
//                 </Row>
//               </Container>
//             </TabPanel>
//           </TabContext>
//         </Box>
//       </section>
//     </>
//   );
// }

// export default CoPmsSection;


import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./CoPmsSection.css"
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { useNavigate, useParams } from "react-router-dom";

// 👉 Your new components
import AboutJmCoPms from "./AboutJmCoPms/AboutJmCoPms";
import InvestorComplaintData from "./InvestorComplaintData/InvestorComplaintData";
import AboutJm from "./AboutJm/AboutJm";

function CoPmsSection() {
  const navigate = useNavigate();
  const { tabName } = useParams();

  const tabs = [
    { id: 1, name: "About JM CO-PMS", slug: "about-jm-co-pms" },
    { id: 2, name: "Investor Complaint Data", slug: "investor-complaint-data" },
    { id: 3, name: "About JM", slug: "about-jm" },
  ];

  const getTabFromUrl = () => {
    const found = tabs.find(t => t.slug === tabName);
    return found ? found.id : 1;
  };

  const [value, setValue] = useState(() => getTabFromUrl());

 useEffect(() => {
  setValue(getTabFromUrl());
}, [tabName]);

  const handleChange = (event, newValue) => {
    const selectedTab = tabs.find(t => t.id === newValue);
    setValue(newValue);
    navigate(`/co-pms/${selectedTab.slug}`);
  };

  return (
    <section className="FinQSection-detail">
      {/* ===== Breadcrumb ===== */}
      {/* <Container>
        <Row>
          <Col>
            <ul className="navigator-arrow">
              <li>
                <a href="/">
                  <i className="fa fa-home" />
                </a>
                <i className="fa fa-angle-right" />
              </li>
              <li>
                <a href="/co-pms">
                  <i>CO-PMS</i>
                </a>
                <i className="fa fa-angle-right" />
              </li>
              <li>{tabs[value - 1]?.name}</li>
            </ul>
          </Col>
        </Row>
      </Container> */}

      {/* ===== Tabs ===== */}
      <Box>
        <TabContext value={value}>
          <Container className="finqtab">
            <Row>
              <Col sm={12}>
                <Box sx={{ display: "flex",
                           justifyContent: "center", 
                           borderBottom: 0 }}>
                  <TabList
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                      width : "auto",
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                  >
                    {tabs.map(tab => (
                      <Tab
                        key={tab.id}
                        label={tab.name}
                        value={tab.id}
                         sx={{
                          minWidth: "unset",   // 🔥 stop each tab from stretching
                          px: 3,               // padding only
                        }}
                      />
                    ))}
                  </TabList>
                </Box>
              </Col>
            </Row>
          </Container>

          {/* ===== Header ===== */}
          <div className="section-header">
            <h2 className="sectionHeaderFinQ">
              {tabs[value - 1]?.name}
            </h2>
          </div>

          {/* ===== Panels ===== */}
          <TabPanel value={1}>
            <AboutJmCoPms />
          </TabPanel>

          <TabPanel value={2}>
            <InvestorComplaintData />
          </TabPanel>

          <TabPanel value={3}>
            <AboutJm />
          </TabPanel>

        </TabContext>
      </Box>
    </section>
  );
}

export default CoPmsSection;
